import { VenueAddressFragment, VenueInfoFragment } from "~graphql/sdk";

export function getEventVenueLocation(
  venue: VenueInfoFragment & VenueAddressFragment
) {
  return venue?.name ? `${venue?.name}, ${venue?.address?.city}` : "";
}
